const GLOW = {
    amber: "led-glow-amber",
    red: "led-glow-red",
    blue: "led-glow-blue",
};

export const LedTicker = ({ messages, accent = "amber", className = "" }) => {
    const line = messages.join("   ◆   ");
    return (
        <div
            data-testid="led-ticker"
            className={`led-board-dots overflow-hidden border-y border-[#2a1f05] bg-[#0c0903] py-3 ${className}`}
            aria-label={line}
        >
            <div className="animate-led-marquee flex whitespace-nowrap">
                {[0, 1].map((n) => (
                    <span
                        key={n}
                        aria-hidden={n === 1}
                        className={`font-led pr-16 text-xl uppercase tracking-[0.25em] md:text-2xl ${GLOW[accent]}`}
                    >
                        {line}   ◆
                    </span>
                ))}
            </div>
        </div>
    );
};
